import "../../../constants/index.js";
import { parseQs } from "../../../utils/qs.js";
import { transformListWithSpec } from "../../../utils/response.js";
import { require200Status } from "../../utils/response.js";
import { FundingModelConvertSpec, GameTxModelConvertSpec } from "../../../types/models/transaction.specs.js";
function transactionEndpoints(builder) {
  return {
    getFundingHistory: builder.query({
      providesTags: ["funding-tx"],
      query: ({ query }) => ({
        url: `/member/funding/tx/list${parseQs(query)}`,
        validateStatus: require200Status
      }),
      transformResponse: transformListWithSpec(FundingModelConvertSpec)
    }),
    getBettingHistory: builder.query({
      providesTags: ["game-tx"],
      query: ({ query }) => ({
        url: `/member/game/tx/list${parseQs(query)}`,
        validateStatus: require200Status
      }),
      transformResponse: transformListWithSpec(GameTxModelConvertSpec)
    })
  };
}
export {
  transactionEndpoints as default
};
